import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { IconCopy } from '@redteclab/icons'

import { Dialog, DialogContent, DialogTitle, Input } from 'base-ui'

import { type StoryblokVoucherCardType } from '../../model/storyblokTypes.generated'
import { useCmsRichTextRender } from '../../useCmsRichTextRender'
import { StoryblokComponentsRenderer } from '../StoryblokComponentsRenderer'

import { StoryblokVoucherCardButtonCopy } from './StoryblokVoucherCardButtonCopy'

type StoryblokVoucherCardModalProps = StoryblokVoucherCardType & {
  isModalOpen: boolean
  onCloseModal: () => void
}

export const StoryblokVoucherCardModal: FC<StoryblokVoucherCardModalProps> = ({
  isModalOpen,
  onCloseModal,
  overlayContent,
  overlayTitle,
  promoCode,
}) => {
  const cmsRenderRichText = useCmsRichTextRender()
  const intl = useIntl()

  return (
    <Dialog onClose={onCloseModal} open={isModalOpen}>
      <DialogTitle
        onClose={onCloseModal}
        slotProps={{
          closeButton: {
            'aria-label': intl.formatMessage({
              id: 'general.link.label.close',
            }),
          },
        }}
      >
        {cmsRenderRichText(overlayTitle)}
      </DialogTitle>

      <DialogContent className="p-0">
        {promoCode ? (
          <div className="flex flex-col gap-2 bg-light-brand-medium p-6 tablet:flex-row tablet:gap-4">
            <Input className="w-full" disabled value={promoCode} />
            <StoryblokVoucherCardButtonCopy
              startIcon={<IconCopy color="white" />}
              textToCopy={promoCode}
            >
              <FormattedMessage id="voucherBox.input.shortLabel.button" />
            </StoryblokVoucherCardButtonCopy>
          </div>
        ) : null}
        <div className="flex flex-col gap-6 p-5">
          <StoryblokComponentsRenderer bloks={overlayContent} />
        </div>
      </DialogContent>
    </Dialog>
  )
}
